import React from "react";
import { Drawer } from "@material-ui/core";
import { PdfViewer } from "@loanbossinc/pdf-viewer";
import "@loanbossinc/pdf-viewer/lib/index.css";
import { downloadFileAsArrayBuffer } from "../../utils/api";

export default class ReferenceDrawer extends React.Component {
  getBufferForFile = async file => {
    const buffer = await downloadFileAsArrayBuffer(`files/${file.id}`);
    return buffer;
  };

  render() {
    return (
      <Drawer
        id="pdfReferenceDrawer"
        onClose={this.props.onClose}
        anchor="right"
        open={this.props.open}
        style={{ minWidth: "500px", maxWidth: "1400px", width: "50%" }}
      >
        <PdfViewer
          flags={this.props.flags}
          mode={this.props.mode}
          currentFile={this.props.currentFile}
          getBufferForFile={this.getBufferForFile}
          modelId={this.props.modelId}
          referencedFieldPath={this.props.referencedFieldPath}
          references={this.props.references}
          referenceFields={this.props.referenceFields}
          onAddReference={this.props.onAddReference}
          onUpdateReferences={this.props.onUpdateReferences}
          onRemoveReference={this.props.onRemoveReference}
          onClose={this.props.onClose}
          onBack={this.props.onBack}
          onBackLabel={this.props.onBackLabel}
          canDelete={this.props.canDelete}
        />
      </Drawer>
    );
  }
}
